/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';

/**
 * 
 * @export
 * @interface EventIdentifiers
 */
export interface EventIdentifiers {
    /**
     * 
     * @type {EventName}
     * @memberof EventIdentifiers
     */
    event_name: EventName;
}

/**
 * Check if a given object implements the EventIdentifiers interface.
 */
export function instanceOfEventIdentifiers(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;

    return isInstance;
}

export function EventIdentifiersFromJSON(json: any): EventIdentifiers {
    return EventIdentifiersFromJSONTyped(json, false);
}

export function EventIdentifiersFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventIdentifiers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
    };
}

export function EventIdentifiersToJSON(value?: EventIdentifiers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
    };
}

